import PageLayout, { Section } from "./PageLayout";
import { Heart, Globe, Sparkles } from "lucide-react";

export default function About() {
  const stats = [
    { v: "120+", l: "Countries served" },
    { v: "25M", l: "Hours streamed" },
    { v: "4K HDR", l: "Highest quality" },
    { v: "12", l: "Languages supported" },
  ];

  return (
    <PageLayout
      eyebrow="About Djino"
      title="Cinema, without borders."
      subtitle="We believe great stories should travel — from a Kinshasa rooftop to a Lagos living room to a New York subway."
      hero="https://images.unsplash.com/photo-1568609159926-5bfc94b48aa1?w=1920&q=85"
    >
      <Section title="Our story">
        <p>Djino Stream was founded in 2025 by a small group of filmmakers, engineers and African storytellers who were tired of seeing their stories pushed to the bottom of someone else's catalog. We built Djino to put African and global cinema on equal footing — beautifully, fast, and on every device.</p>
        <p>Today we serve millions of streams a month across desktops, mobiles, smart TVs and the open web. We're independent, profitable, and growing without venture pressure to compromise our values.</p>
      </Section>

      <Section title="What we believe">
        <div className="grid sm:grid-cols-3 gap-4">
          {[
            { icon: Heart, title: "Stories first", desc: "Tech serves storytelling — not the other way around." },
            { icon: Globe, title: "Global reach, local soul", desc: "We invest in originals from underserved regions." },
            { icon: Sparkles, title: "Premium feels obvious", desc: "Speed, design and craft are non-negotiable." },
          ].map((v, i) => (
            <div key={i} className="bg-[#0d0d0d] border border-white/5 rounded-xl p-6">
              <v.icon className="text-[#E50914] mb-3" size={22} />
              <div className="font-bold text-lg mb-1" style={{ fontFamily: "Outfit" }}>{v.title}</div>
              <div className="text-sm text-[#aaa]">{v.desc}</div>
            </div>
          ))}
        </div>
      </Section>

      <Section title="By the numbers">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#0d0d0d] border border-white/5 rounded-xl p-5 text-center">
              <div className="text-3xl sm:text-4xl font-black text-white" style={{ fontFamily: "Outfit" }}>{s.v}</div>
              <div className="text-xs text-[#888] uppercase tracking-wider mt-1">{s.l}</div>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Leadership">
        <div className="grid sm:grid-cols-3 gap-4">
          {[
            { name: "Patrick Mbala", role: "Founder & CEO" },
            { name: "Ngozi Eze", role: "Head of Content" },
            { name: "Marc Devereux", role: "CTO" },
          ].map((p, i) => (
            <div key={i} className="bg-[#0d0d0d] border border-white/5 rounded-xl p-5">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#E50914] to-[#7a0a0e] flex items-center justify-center text-white font-black text-xl mb-3" style={{ fontFamily: "Outfit" }}>
                {p.name[0]}
              </div>
              <div className="font-semibold">{p.name}</div>
              <div className="text-xs text-[#888]">{p.role}</div>
            </div>
          ))}
        </div>
      </Section>
    </PageLayout>
  );
}
